import React, { Fragment } from 'react';
import { Card, CardBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import { primeiraImagemDeUmaNoticia } from '../../../services/noticias';

function CardNoticiaMaisLida(props) {
    const { noticias, noticiaAtual } = props;
    return (
        noticias.filter((noticia) => noticiaAtual !== undefined ? noticia?.id !== noticiaAtual["id"] : noticia ).length > 0 && <Fragment>
            <h3 className="font-weight-bold azul-principal mb-3">Mais Lidas</h3>
            <Card>
                <CardBody>
                    {
                        noticias.filter((noticia) => noticiaAtual !== undefined ? noticia?.id !== noticiaAtual["id"] : noticia ).map(noticia => {
                            return (
                                <Link to={`/eventos-e-noticias/${noticia.id}`} key={noticia.id}>
                                    <div className="d-flex mb-4 align-middle">
                                        <img
                                            src={primeiraImagemDeUmaNoticia(noticia)}
                                            className="shadow-sm"
                                            alt=""
                                            style={{ height: "90px", width: "90px", borderRadius: "16px", objectFit: "cover" }}
                                        />
                                        <span className="align-middle font-weight-bold my-auto ml-2 azul-principal">
                                            {(noticia.titulo).substring(0, 50)}
                                        </span>
                                    </div>
                                </Link>
                            )
                        })
                    }
                </CardBody>
            </Card>
        </Fragment>
    );
}

export default CardNoticiaMaisLida;